import OneTimeFee from "./one-time-fee.component";

export default OneTimeFee;
